const autocompleteModalFilterExpiredServices = {
  site: 'Sitios',
  equipments: 'Tipo del Equipo',
  equipmentGroups: 'Grupo del Equipo',
  place: 'Lugar',
  area: 'Departamentos',
  serviceTypes: 'Tipo de servicio',
  companies: 'Tercera empresa',
  frequencies: 'Periodicidad',
  
};

export default autocompleteModalFilterExpiredServices;
